module.exports = __webpack_public_path__ + "static/sock-a49370099ade15cb58b279289b9506b2.svg";